import * as React from 'react';
import type { ProjectId, AssetId } from 'owa-timestream-types';
import { trackAssetSize } from 'owa-timestream-store';
import { useResizeObserver } from 'owa-react-hooks/lib/useResizeObserver';

export default function useTrackAssetSize(
    projectId: ProjectId,
    assetId: AssetId,
    assetRef: React.RefObject<HTMLDivElement>
) {
    useResizeObserver(
        assetRef,
        React.useCallback(() => {
            if (assetRef.current) {
                trackAssetSize(
                    projectId,
                    assetId,
                    assetRef.current.offsetWidth,
                    assetRef.current.offsetHeight
                );
            }
        }, [projectId, assetId])
    );
}
